export default "__VITE_ASSET__Bj$pVamI__"